
import { Stack, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { Floor } from 'utils/floor';

interface FloorCardProps {
  floor: Pick<Floor, 'name' | 'image'>;
}

const FloorCard: React.FC<FloorCardProps> = ({ floor }) => {
  
  const size = '15rem'

  return (
    <Stack spacing={1} sx={{ position: 'relative', zIndex: 1 }}>
      <img
        src={floor.image}
        alt={floor.name}
        style={{ width: size, height: size, borderRadius: '8px', objectFit: 'contain', background: '#fff2' }}
      />
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography>{floor.name}</Typography>
      </Stack>
    </Stack>
  );
};

export default FloorCard;